import {useState} from 'react'
import Spinner from '../Spinner/Spinner'
import { Setter } from '../../services/ComService'
import mainservice from '../../services/MainService'
import { i18n } from '../../services/i18n'

enum Status {
  start,
  loading,
  mailFormatError,
  registerError,
  errorLoggedIn,
  done
}

const DoRegister = async (emailRaw: string, firstname: string, surname: string, company: string) => {
  const emailArr = emailRaw.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/)
  if (!emailArr) {
    return Status.mailFormatError
  }
  const email = emailArr[0]
  const challenge: {
    timestamp: number,
    question: string
  } | any = await Setter('user/register/challenge', {
    email: email
  })
  if (!challenge) { return Status.registerError }
  console.log('challenge', challenge)
  if (challenge.reason === 'loggedIn') { return Status.errorLoggedIn }
  const q = challenge.question
  if (!q) { return Status.registerError }
  const answer = `${challenge.timestamp * 3}${email[2]}${email[4]}${email[1]}${email[0]}${email[2]}${email[3]}_${q.substr(0,4)}_${challenge.timestamp * 2}`
  await Setter('user/register', {
    email: email,
    timestamp: challenge.timestamp,
    answer: answer,
    firstname: firstname,
    surname: surname,
    company: company
  }, {retryName: `${email}`})
  return Status.done
}

function ShowRegisterFormular (props: {
  setStatus: (s: Status) => void,
  status: Status,
  mode?: 'normal' | 'forgotPassword'
}) {
  const [email, setEmail] = useState('')
  const [firstname, setFirstname] = useState('')
  const [surname, setSurname] = useState('')
  const [company, setCompany] = useState('')
  const [status, setStatus] = useState(props.status)
  return <div className='w3-container'>
      {
        props.mode !== 'forgotPassword' &&
        <>
          <label>{i18n('registerFirstName')}</label>
          <input
            className='w3-input'
            onChange={(event) => {
              setFirstname(event.target.value)
            }}
            value={firstname}
          ></input>
          <label>{i18n('registerLastName')}</label>
          <input
            className='w3-input'
            onChange={(event) => {
              setSurname(event.target.value)
            }}
            value={surname}
          ></input>
          <label>{i18n('registerCompany')}</label>
          <input
            className='w3-input'
            onChange={(event) => {
              setCompany(event.target.value)
            }}
            value={company}
          ></input>
        </>
      }
      <label>{i18n('emailLabel')}</label>
      <input
        className='w3-input'
        onChange={(event) => {
          setEmail(event.target.value)
        }}
        onKeyDown={async (event) => {
          if (event.key === 'Enter') {
            setStatus(Status.loading)
            const newStatus = await DoRegister(email, firstname, surname, company)
            if (!newStatus) { return }
            if (newStatus === Status.done) {
              props.setStatus(newStatus)
            }
            else {
              setStatus(newStatus)
            }
          }
        }}
      ></input>
      {
        status === Status.mailFormatError &&
        <div className='error-box'>
          {i18n('emailFormatError')}
        </div>
      }
      <button
        className='w3-btn w3-ripple register-button'
        onClick={async () => {
          setStatus(Status.loading)
          const newStatus = await DoRegister(email, firstname, surname, company)
          if (!newStatus) { return }
          if (newStatus === Status.done) {
            props.setStatus(newStatus)
          }
          else {
            setStatus(newStatus)
          }
        }}
      >
        {
          props.mode === 'forgotPassword' ? i18n('loginHintSendPassword') : i18n('registerHeadline')
        }
      </button>
    </div>
}

function UserRegister (props: {
  showAsElement?: boolean,
  className?: string
  mode?: 'normal' | 'forgotPassword'
}) {
  const [status, setStatus] = useState(Status.start)
  const content = () => {
    if (mainservice.loginService.user.id > 0) {
      return <div className='w3-container'>
        <p>
          {i18n('registerErrLoginCanNotRegister')}
        </p>
        <p className='w3-center fontSize8'>🤷</p>
      </div>
    }
    switch(status) {
      case Status.start:
      case Status.mailFormatError:
        return <ShowRegisterFormular
            setStatus={(s: Status) => setStatus(s)}
            status={status}
            mode={props.mode}
          />
      case Status.loading:
        return <div className='w3-container'>
            <p>{i18n('registerInProgress')}</p>
            <p className='w3-center'><Spinner
            mini={true}
            sizeClass='normalSize'
            /></p>
          </div>
      case Status.done:
        return <div className='w3-container'>
          <p>
            {
              props.mode === 'forgotPassword' ? i18n('registerForgotPasswordHint') : i18n('registerReceived')
            }
            
          </p>
          <p className='w3-center fontSize8'>📬</p>
          <p className='w3-padding-16'>
            {
              props.mode === 'forgotPassword' ? i18n('registerPleaseClickEmailLink1') : i18n('registerPleaseClickEmailLink2')
            }
          </p>
        </div>
      case Status.errorLoggedIn:
        return <div className='w3-container'>
          <p>
            {
              props.mode === 'forgotPassword' ? i18n('registerPasswordChangeHint1') : i18n('registerPasswordChangeHint2')
            }
          </p>
          <p className='w3-center fontSize8'>🤷</p>
        </div>
    }
  }
  if (props.showAsElement) {
    return <div className={props.className !== undefined ? props.className : 'w3-card-4 lu-dialog'}>
      <div className='w3-container lu-headline'>{i18n('registerHeadline')}</div>
      { content() }
    </div>
  }
  return <div className={`w3-row`}>
    <div className="w3-col l4 m3 s0">&nbsp;</div>
    <div className='w3-card-4 lu-dialog w3-col l4 m6 s12'>
      <div className='w3-container lu-headline'>{i18n('registerHeadline')}</div>
      { content() }
    </div>
  </div>

}

export default UserRegister
